import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Table } from 'reactstrap';
import { ReactSortable } from 'react-sortablejs';
import { consumesTemplates, providesTemplates } from 'contexts/TemplatesContext';
import { providesUsedCompanies } from 'contexts/UsedCompaniesContext';
import TemplateListEntry from 'components/templateListEntry/TemplateListEntry';
import { consumesDossier } from 'contexts/DossierContext';
import RemoteDataPropType from 'lib/prop-types/RemoteDataPropType';
import translate from 'containers/translate';
import withCompanies from 'containers/withCompanies';
import './TemplateList.scss';

class TemplateList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      wrappedTemplates: props.templates.map((template) => ({ id: template.id, template })),
    };

    this.onCreateNewTemplate = this.onCreateNewTemplate.bind(this);
    this.onTemplateChange = this.onTemplateChange.bind(this);
    this.onTemplateDelete = this.onTemplateDelete.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.templates !== this.props.templates) {
      this.setState({
        wrappedTemplates: this.props.templates.map((template) => ({ id: template.id, template })),
      });
    }
  }

  onCreateNewTemplate() {
    this.props.remoteTemplates.api.create();
  }

  onTemplateChange(template) {
    this.props.remoteTemplates.api.update(template);
  }

  onTemplateDelete(template) {
    this.props.remoteTemplates.api.delete(template);
  }

  renderTemplates() {
    return this.state.wrappedTemplates.map((wrapper, index) => {
      return (
        <TemplateListEntry
          dossier={this.props.dossier}
          template={wrapper.template}
          key={wrapper.template.id}
          index={index}
          companyNames={this.props.companyNames}
          locked={false}
          onTemplateChange={this.onTemplateChange}
          onTemplateDelete={this.onTemplateDelete}
        />
      );
    });
  }

  render() {
    const { t } = this.props;

    return (
      <div className={'TemplateList'}>
        <Table>
          <thead>
            <tr>
              <td />
              <th>{t('name')}</th>
              <th>{t('company')}</th>
              <th>{t('account')}</th>
              <th>{t('vat')}</th>
              <th>{t('accounting_text')}</th>
              <th />
            </tr>
          </thead>
          <ReactSortable
            list={this.state.wrappedTemplates}
            setList={(newList) => this.setState({ wrappedTemplates: newList })}
            onEnd={(evt) => {
              if (evt.oldIndex !== evt.newIndex) {
                const movedTemplate = this.state.wrappedTemplates[evt.newIndex].template;
                this.onTemplateChange({
                  ...movedTemplate,
                  position: evt.newIndex,
                });
              }
            }}
            tag="tbody"
            animation={150}
            handle=".drag-handle"
            moveThreshold={0}
          >
            {this.renderTemplates()}
          </ReactSortable>
          <tfoot>
            <tr>
              <td colSpan="7">
                <Button type="button" onClick={this.onCreateNewTemplate} color="primary">
                  {t('add')}
                </Button>
              </td>
            </tr>
          </tfoot>
        </Table>
      </div>
    );
  }
}

TemplateList.propTypes = {
  t: PropTypes.func.isRequired,
  templates: PropTypes.arrayOf(PropTypes.object).isRequired,
  remoteTemplates: RemoteDataPropType,
  dossier: PropTypes.object.isRequired,
  companyNames: PropTypes.array.isRequired,
};

export default providesUsedCompanies(
  consumesDossier(providesTemplates(consumesTemplates(withCompanies(translate(TemplateList)))))
);
